import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { API_URL } from '../config/api';
import './SignUp.css'; // Reusing SignUp styles

function SignIn() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      toast.error('Please enter your email');
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('Verification code sent to your email!');
        navigate('/verify-login', {
          state: { email }
        });
      } else {
        toast.error(data.error || 'Failed to send verification code. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <div className="signup-header">
          <h1>Welcome Back to <span>Dstribute</span></h1>
          <p>Sign in to your account to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="signup-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              disabled={isLoading}
              className="form-input"
            />
          </div>

          <button
            type="submit"
            className="signup-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Continue with Email'}
          </button>
        </form>

        <div className="signup-footer">
          <p>
            Don't have an account?{' '}
            <Link to="/company" style={{ color: '#ff4000', textDecoration: 'none', fontWeight: 600 }}>
              Sign Up
            </Link>
          </p>
          <p style={{ fontSize: '14px', marginTop: '10px' }}>
            We'll send you a verification code to confirm your email
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignIn;